import * as React from 'react';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Box } from '@mentimeter/ragnar-ui/box';

export const CenteringContainer = ({
  children,
  ...rest
}: React.PropsWithChildren<BoxT>) => {
  return (
    <Box
      flex="1 1 auto"
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
      {...rest}
    >
      {children}
    </Box>
  );
};
